import { decamelizeKeys } from 'humps'

import BaseApi from '@/api/base-api'

class MerchantInstoreMaterialDeliveryApi extends BaseApi {
  fetchList = (data) => {
    const dataToBeSent = decamelizeKeys(data, (key, convert) =>
      /^searchText/.test(key) ? key : convert(key)
    )

    return this.request(
      {
        method: 'GET',
        path: this.uri + '/deliveries',
        data: dataToBeSent,
      },
      {
        options: {
          cache: true,
        },
      }
    )
  }

  updateStatus = (data) => {
    const dataToBeSent = decamelizeKeys(data)

    return this.request({
      method: 'POST',
      path: this.uri + '/update-status',
      data: dataToBeSent,
    })
  }
}

export default new MerchantInstoreMaterialDeliveryApi(
  '/merchants/instore-material-delivery'
)
